import { cn } from "@/lib/utils";

export const LEVEL = {
  low: ["Low", "bg-emerald-50 text-emerald-700 border-emerald-200", "#059669"],
  medium: ["Medium", "bg-amber-50 text-amber-800 border-amber-200", "#D97706"],
  high: ["High", "bg-rose-50 text-rose-700 border-rose-200", "#E11D48"],
  standard: ["Standard", "bg-amber-50 text-amber-800 border-amber-200", "#D97706"],
  not_set: ["Not set", "bg-slate-100 text-slate-600 border-slate-200", "#94A3B8"],
};
export const SAT = {
  pass: ["Pass", "bg-emerald-50 text-emerald-700 border-emerald-200", "#059669"],
  review: ["Review", "bg-amber-50 text-amber-800 border-amber-200", "#D97706"],
  fail: ["Fail", "bg-rose-50 text-rose-700 border-rose-200", "#E11D48"],
  pending: ["Pending — satellite check unavailable", "bg-slate-100 text-slate-600 border-slate-300", "#64748B"],
};
export const ASTATUS = {
  draft: ["Draft", "bg-slate-100 text-slate-600 border-slate-200", "#94A3B8"],
  prepared: ["Prepared", "bg-sky-50 text-sky-700 border-sky-200", "#0284C7"],
  approved: ["Approved", "bg-emerald-50 text-emerald-700 border-emerald-200", "#059669"],
  reassessment_needed: ["Re-assessment needed", "bg-orange-50 text-orange-800 border-orange-200", "#EA580C"],
};

export function Chip({ map, value, testid, className }) {
  const v = map[value || "not_set"] || map.not_set || ["—", "bg-slate-100 text-slate-500 border-slate-200"];
  return <span data-testid={testid} className={cn("inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide", v[1], className)}>{v[0]}</span>;
}
